import React from 'react';
import ImageUpload from './ImageUpload';
import { handleRemoveGroupImage } from './handlers';
import { REWARD_TYPES, hasVariantsWithQuantity, hasPricingAndQuantityFields } from "./utils";

const GroupHeader = ({
  name,
  count,
  groupedVariants,
  options,
  setOptions,
  setVariants,
  handleImageUpload,
  handleOptionValueChange,
  updateVariant,
  opts,
  canAddVariants
}) => {
  // Calculate prices only from enabled variants
  const enabledVariants = groupedVariants.filter(variant => variant.enabled);
  const prices = enabledVariants.map(variant => variant.faceValue);
  const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
  const maxPrice = prices.length > 0 ? Math.max(...prices) : 0;
  const hasRange = minPrice !== maxPrice;

  const option = options.find(option =>
    option.values.some(value => value.name.toLowerCase() === name.toLowerCase())
  );
  const optionValue = options.flatMap(option => option.values)
    .find(value => value.name.toLowerCase() === name.toLowerCase()) || null;
  const optionImage = optionValue?.image || null;

  const handlePriceChange = (e) => {
    const newValue = e.target.value;
    handleOptionValueChange(option.id, optionValue.id, "faceValue", newValue, setOptions);
    
    // Only update prices for enabled variants
    groupedVariants
      .filter(variant => variant.enabled)
      .forEach(variant => 
        updateVariant(e, variant.id, "faceValue", newValue, setVariants)
      );
  };

  const handleGroupHeaderImageUpload = (e, url) => {
    handleOptionValueChange(option.id, optionValue.id, "image", url, setOptions);
    
    // Only update images for enabled variants
    groupedVariants
      .filter(variant => variant.enabled)
      .forEach(variant => 
        updateVariant(e, variant.id, "image", url, setVariants)
      );
  };

  const renderPriceInput = () => (
    (hasPricingAndQuantityFields(opts)) && (
      <td className="text-center">
        <input
          type="text"
          className="form-control"
          placeholder="Enter price"
          value={hasRange ? `${minPrice} - ${maxPrice}` : minPrice}
          onChange={handlePriceChange}
          onFocus={(e) => e.target.value = ''}
          disabled={canAddVariants}
        />
      </td>
    )
  );

  const renderEmptyCells = () => {
    const cells = [];
    { hasPricingAndQuantityFields(opts) && cells.push(<td key="quantity" className="text-center"></td>) }
    { (opts.reward_type === REWARD_TYPES.COMPANY_FULFILLED) && cells.push(<td key="sku" className="text-center"></td>) }
    // Add empty cell for redemptions column only if has_variants_with_quantity is true
    { hasVariantsWithQuantity(opts) && cells.push(<td key="redemptions" className="text-center"></td>) }
    return cells;
  };

  return (
    <tr className="align-middle grouped-variants table-light" style={{ height: '40px' }}>
      <td className="text-center">
        <ImageUpload
          value={optionImage}
          onChange={(e) => handleImageUpload(e, handleGroupHeaderImageUpload)}
          onRemove={(e) => handleRemoveGroupImage(e, option, optionValue, setOptions, groupedVariants, setVariants)}
          disabled={canAddVariants}
        />
      </td>
      <td className="text-center">
        <div className="d-flex align-items-center gap-2">
          <strong>{name}</strong> 
          <span className="ms-2 text-muted">({count} variants)</span>
        </div>
      </td>
      {renderPriceInput()}
      {renderEmptyCells()}
    </tr>
  );
};

export default GroupHeader;